import { render, staticRenderFns } from "./donationReceiptModal.vue?vue&type=template&id=613935e8&scoped=true&"
import script from "./donationReceiptModal.vue?vue&type=script&lang=js&"
export * from "./donationReceiptModal.vue?vue&type=script&lang=js&"
import style0 from "./donationReceiptModal.vue?vue&type=style&index=0&id=613935e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613935e8",
  null
  
)

export default component.exports